import React, { useState } from 'react';
import ErrorBound from '@ff/ui/ErrorBoundary';
import PATHS from '../utils/paths';
import url from '../utils/url';
import UIError from '../utils/UIError';
import appHandlers from 'client/utils/appHandlers';

export default function ErrorBoundary(props) {
  const region = url.getRegion();
  const isApp = url.isAppOnly();
  const onCloseAppH5 = appHandlers.getHandlerByKey('CloseConfigurator');
  const [data, setData] = useState({
    message: '',
    link: `/${region.toLowerCase()}${PATHS.FF91_DESIGN_PREFIX}/model${isApp ? '?APPONLY=1' : ''}`
  });

  const handleError = (error, errorInfo) => {
    if (error instanceof UIError && error.data) {
      setData(error.data);
    }

    console.error(error, errorInfo);
  };

  return (
    <ErrorBound
      minHeight='100vh'
      onError={handleError}
      message={data.message}
      link={data.link}
      isAppH5={isApp}
      onCloseAppH5={onCloseAppH5}
    >
      {props.children}
    </ErrorBound>
  );
}
